import { render, staticRenderFns } from "./comorbiditiesTable.vue?vue&type=template&id=3fd1e326&scoped=true"
import script from "./comorbiditiesTable.vue?vue&type=script&lang=ts"
export * from "./comorbiditiesTable.vue?vue&type=script&lang=ts"
import style0 from "./comorbiditiesTable.vue?vue&type=style&index=0&id=3fd1e326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd1e326",
  null
  
)

export default component.exports